import {Component, ViewChildren, QueryList, AfterViewInit, inject} from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { TramitesHistorialComponent } from './tramites-historial/tramites-historial.component';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    TabViewModule, TranslateModule, CustomTitle,
    TramitesHistorialComponent
  ],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss', '../../../../assets/styles/style.mantenimiento.scss']
})
export class LandingComponent implements AfterViewInit {
  activeTabIndex: number = 0;

  @ViewChildren(TramitesHistorialComponent) tramitesHistorialComponents !: QueryList<TramitesHistorialComponent>
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor() { }

  ngAfterViewInit(): void {
    this.titleService.changeTitle('msg.misTramites');
    this.tramitesHistorialComponents.get(0)?.getMisTramites();
  }

  activeIndexChange(index: number) {
    if (this.tramitesHistorialComponents && this.tramitesHistorialComponents.length > index) {
      this.tramitesHistorialComponents.get(index)?.getMisTramites();
    }
  }

}
